import React from "react";

interface Props {
    messages: string[];
    className?: string;
    zoom?: number;
    placeholderTextAppear?: string;
}

export const Messages = React.forwardRef<HTMLDivElement, Props>(
    ({ messages, className, zoom, placeholderTextAppear }, ref) => {
        if (messages.length === 0) {
            return (
                <div className="p-4">
                    <div className="flex items-center justify-center h-full">
                        <p className="text-gray-500">{placeholderTextAppear ?? 'No messages...'}</p>
                    </div>
                </div>
            );
        }

        return (
            <div ref={ref} className={`bg-gray-50 rounded-lg p-4 overflow-y-auto ${className}`}>
                <div className="space-y-2" style={zoom ? { fontSize: `${zoom}%` } : {}}>
                    {messages.map((value, index) => (
                        <div key={index} className="bg-white p-4 rounded-lg shadow-sm">
                            <p className="text-gray-600">{value}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
);
